"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SaveCancelInstance = SaveCancelInstance;
const lodash_1 = __importDefault(require("lodash"));
const uuid_1 = __importDefault(require("uuid"));
const react_1 = __importStar(require("react"));
const localization_1 = require("../localization");
const VirtualDatabase_1 = __importDefault(require("../../database/VirtualDatabase"));
const ContextVarsInjector_1 = __importDefault(require("../ContextVarsInjector"));
/** Instance swaps out the database for a virtual database */
function SaveCancelInstance(props) {
    /** Stores validation registrations for all sub-components so that they can be validated
     * before being saved.
    */
    const validationRegistrations = (0, react_1.useRef)({});
    (0, react_1.useEffect)(() => {
        const unregisterValidation = props.instanceCtx.registerForValidation(validate);
        return () => {
            unregisterValidation();
        };
    }, []);
    const virtualDatabase = (0, react_1.useMemo)(() => new VirtualDatabase_1.default(props.instanceCtx.database, props.instanceCtx.schema, props.instanceCtx.locale), []);
    /** True when control has been destroyed by save or cancel */
    const [destroyed, setDestroyed] = (0, react_1.useState)(false);
    /** True when control is saving */
    const [saving, setSaving] = (0, react_1.useState)(false);
    // Stores the ID of the row that was added if it was added
    const [addedRowId, setAddedRowId] = (0, react_1.useState)(null);
    const doesNeedAdd = () => {
        return (props.blockDef.addTable != null &&
            (!props.blockDef.addExistingContextVarId ||
                !props.instanceCtx.contextVarValues[props.blockDef.addExistingContextVarId]));
    };
    const performAdd = async () => {
        // Create row to insert
        const row = {};
        const addColumnValues = props.blockDef.addColumnValues || {};
        for (const columnId of Object.keys(addColumnValues)) {
            const contextVarExpr = addColumnValues[columnId];
            row[columnId] = props.instanceCtx.getContextVarExprValue(contextVarExpr.contextVarId, contextVarExpr.expr);
        }
        try {
            const txn = virtualDatabase.transaction();
            await txn.addRow(props.blockDef.addTable, row);
            const addedRowId = (await txn.commit())[0];
            setAddedRowId(addedRowId);
        }
        catch (err) {
            // TODO localize
            alert("Unable to add row: " + err.message);
            return;
        }
    };
    (0, react_1.useEffect)(() => {
        if (doesNeedAdd()) {
            performAdd().catch(err => {
                // TODO localize
                alert("Unable to add row: " + err.message);
            });
        }
    }, []);
    const validate = () => {
        // Confirm if changes present
        if (virtualDatabase.mutations.length > 0) {
            if (!confirm((0, localization_1.localize)(props.blockDef.confirmDiscardMessage, props.instanceCtx.locale))) {
                // Return empty string to block without message
                return "";
            }
        }
        return null;
    };
    const handleSave = async () => {
        // Validate all instances that have registered
        const validationMessages = [];
        for (const validator of Object.values(validationRegistrations.current)) {
            const msg = await validator(validationMessages.length == 0);
            if (msg != null) {
                validationMessages.push(msg);
            }
        }
        if (validationMessages.length > 0) {
            // "" just blocks
            if (lodash_1.default.compact(validationMessages).length > 0) {
                alert(lodash_1.default.compact(validationMessages).join("\n"));
            }
            return;
        }
        setSaving(true);
        let mutations = [];
        try {
            mutations = await virtualDatabase.commit();
            setSaving(false);
            setDestroyed(true);
            await props.instanceCtx.pageStack.closePage();
        }
        catch (err) {
            // TODO localize
            alert("Unable to save changes: " + err.message);
            setSaving(false);
            return;
        }
        // Perform post-add action
        if (props.addContextVar && props.blockDef.postAddAction) {
            const action = props.instanceCtx.actionLibrary.createAction(props.blockDef.postAddAction);
            // Get added row ID from mutations
            if (mutations.length == 0 || mutations[0].type != "add") {
                throw new Error("Unable to get added row ID");
            }
            const addedRowId = mutations[0].primaryKey;
            // Create props
            const addRowProps = {
                ...props.instanceCtx,
                contextVars: props.instanceCtx.contextVars.filter(cv => cv.id != props.addContextVar.id).concat(props.addContextVar),
                contextVarValues: {
                    ...props.instanceCtx.contextVarValues,
                    [props.addContextVar.id]: addedRowId
                }
            };
            await action.performAction(addRowProps);
        }
    };
    const handleCancel = () => {
        virtualDatabase.rollback();
        setDestroyed(true);
        props.instanceCtx.pageStack.closePage();
    };
    const handleDelete = async () => {
        const blockDef = props.blockDef;
        // Confirm deletion
        if (blockDef.confirmDeleteMessage &&
            !confirm((0, localization_1.localize)(blockDef.confirmDeleteMessage, props.instanceCtx.locale))) {
            return;
        }
        // Do actual deletion
        const db = props.instanceCtx.database;
        const deleteRow = async (tx, contextVarId) => {
            const deleteCV = props.instanceCtx.contextVars.find((cv) => cv.id == contextVarId);
            if (!deleteCV) {
                throw new Error("Missing delete CV");
            }
            const rowId = props.instanceCtx.contextVarValues[deleteCV.id];
            if (!rowId) {
                return;
            }
            await tx.removeRow(deleteCV.table, rowId);
        };
        try {
            const txn = db.transaction();
            deleteRow(txn, blockDef.deleteContextVarId);
            if (blockDef.extraDeleteContextVarIds) {
                for (const cvId of blockDef.extraDeleteContextVarIds) {
                    deleteRow(txn, cvId);
                }
            }
            await txn.commit();
        }
        catch (err) {
            // TODO localize
            alert("Unable to delete row: " + err.message);
            return;
        }
        virtualDatabase.rollback();
        setDestroyed(true);
        // Always close current page
        await props.instanceCtx.pageStack.closePage();
        // Get main deleted row
        const deletedRowId = props.instanceCtx.contextVarValues[blockDef.deleteContextVarId];
        // While the page stack still has pages, close them if they reference the deleted row
        while (true) {
            const pages = props.instanceCtx.pageStack.getPageStack();
            if (pages.length == 0) {
                break;
            }
            // Get last page
            const lastPage = pages[pages.length - 1];
            // If any context variable values are the deleted row, close the page
            const values = Object.values(lastPage.contextVarValues);
            if (values.some(v => v === deletedRowId)) {
                await props.instanceCtx.pageStack.closePage();
            }
            else {
                break;
            }
        }
    };
    /** Stores the registration for validation of a child block and returns an unregister function */
    const registerChildForValidation = (validate) => {
        const key = (0, uuid_1.default)();
        validationRegistrations.current[key] = validate;
        return () => {
            delete validationRegistrations.current[key];
        };
    };
    const saveLabelText = (0, localization_1.localize)(props.blockDef.saveLabel, props.instanceCtx.locale);
    const cancelLabelText = (0, localization_1.localize)(props.blockDef.cancelLabel, props.instanceCtx.locale);
    const deleteLabelText = (0, localization_1.localize)(props.blockDef.deleteLabel, props.instanceCtx.locale);
    // Replace renderChildBlock with function that keeps all instances for validation
    const instanceCtx = {
        ...props.instanceCtx,
        registerForValidation: registerChildForValidation
    };
    // Determine if row to delete
    let canDelete = props.blockDef.deleteContextVarId != null &&
        props.instanceCtx.contextVarValues[props.blockDef.deleteContextVarId] != null &&
        (props.blockDef.deleteCondition == null ||
            props.blockDef.deleteCondition.expr == null ||
            props.instanceCtx.getContextVarExprValue(props.blockDef.deleteCondition.contextVarId, props.blockDef.deleteCondition.expr) == true);
    if (props.blockDef.extraDeleteContextVarIds) {
        for (const cvId of props.blockDef.extraDeleteContextVarIds) {
            canDelete = canDelete || (cvId != null && props.instanceCtx.contextVarValues[cvId] != null);
        }
    }
    const injectedContextVars = (0, react_1.useMemo)(() => {
        if (props.addContextVar && !props.instanceCtx.contextVars.some(cv => cv.id == props.addContextVar.id)) {
            return [...instanceCtx.contextVars, props.addContextVar];
        }
        else {
            return instanceCtx.contextVars;
        }
    }, [props.addContextVar, instanceCtx.contextVars]);
    const injectedContextVarValues = (0, react_1.useMemo)(() => {
        if (props.addContextVar && addedRowId) {
            return {
                ...instanceCtx.contextVarValues,
                [props.addContextVar.id]: addedRowId
            };
        }
        else {
            return instanceCtx.contextVarValues;
        }
    }, [addedRowId, props.addContextVar, instanceCtx.contextVarValues]);
    if (doesNeedAdd() && !addedRowId) {
        // Render wait while adding
        return (react_1.default.createElement("div", { style: { color: "#AAA", textAlign: "center" } },
            react_1.default.createElement("i", { className: "fa fa-circle-o-notch fa-spin" })));
    }
    if (destroyed) {
        return null;
    }
    // Inject new database and re-inject all context variables. This is needed to allow computed expressions
    // to come from the virtual database
    return (react_1.default.createElement("div", null,
        react_1.default.createElement(ContextVarsInjector_1.default, { injectedContextVars: injectedContextVars, injectedContextVarValues: injectedContextVarValues, innerBlock: props.blockDef.child, instanceCtx: { ...instanceCtx, database: virtualDatabase } }, (innerInstanceCtx, loading, refreshing) => {
            if (loading) {
                return (react_1.default.createElement("div", { style: { color: "#AAA", fontSize: 18, textAlign: "center" } },
                    react_1.default.createElement("i", { className: "fa fa-circle-o-notch fa-spin" })));
            }
            return innerInstanceCtx.renderChildBlock(innerInstanceCtx, props.blockDef.child);
        }),
        react_1.default.createElement("div", { className: "save-cancel-footer" },
            canDelete ? (react_1.default.createElement("button", { type: "button", className: "btn btn-outline-danger", onClick: handleDelete, style: { float: "left" } },
                react_1.default.createElement("i", { className: "fa fa-remove" }),
                " ",
                deleteLabelText)) : null,
            react_1.default.createElement("button", { type: "button", className: "btn btn-primary", onClick: handleSave, disabled: saving },
                saving ? react_1.default.createElement("i", { className: "fa fa-fw fa-spinner fa-spin" }) : null,
                saveLabelText),
            "\u00A0",
            react_1.default.createElement("button", { type: "button", className: "btn btn-secondary", onClick: handleCancel, disabled: saving }, cancelLabelText))));
}
